export default __webpack_public_path__ + "static/media/ofilsystem_v2.9fa855ed.jpg";